export default __webpack_public_path__ + "static/media/credit_card.582022a5.png";